// extracted by css-extract-rspack-plugin
export default {"main":"main-IEeh_B"};// extracted by css-extract-rspack-plugin
export default {"main":"main-IEeh_B"};